import React from 'react';
import { trackEvent } from '../lib/analytics';
import { A8Banner234x60 } from './A8Ads';

interface AdBannerProps {
  onClose?: () => void;
}

const AdBanner: React.FC<AdBannerProps> = ({ onClose }) => {
  const adImageUrl = process.env.REACT_APP_AD_IMAGE_URL || '';
  const adLinkUrl = process.env.REACT_APP_AD_LINK_URL || '';
  const isCustom = Boolean(adImageUrl && adLinkUrl);

  const handleClick = () => {
    trackEvent('ad_click', { placement: 'sidebar_banner' });
  };

  const handleClose = () => {
    trackEvent('ad_close', { placement: 'sidebar_banner' });
    onClose && onClose();
  };

  return (
    <div className="mt-6 p-4 rounded-lg border bg-white shadow-sm">
      <div className="flex items-start justify-between">
        <h3 className="text-sm font-semibold text-gray-700">スポンサーリンク</h3>
        <button aria-label="広告を閉じる" className="text-gray-400 hover:text-gray-600" onClick={handleClose}>
          ✕
        </button>
      </div>
      <div className="mt-3">
        {isCustom ? (
          <a href={adLinkUrl} target="_blank" rel="noreferrer" onClick={handleClick}>
            <img src={adImageUrl} alt="広告" className="w-full rounded-md" />
          </a>
        ) : (
          <div onClick={handleClick}>
            <A8Banner234x60 />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdBanner;


